var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('commonTable',{ref:"commonTable",attrs:{"url":"admin/money_logs/list","reqMethod":"GET","column":_vm.column,"searchColumn":_vm.searchColumn,"limitKey":"per_page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }